import { Component, NgModule, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthService } from '../../services';
import { UserPanelModule } from '../user-panel/user-panel.component';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxToolbarModule } from 'devextreme-angular/ui/toolbar';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: 'header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent {
  @Output()
  menuToggle = new EventEmitter<boolean>();

  @Input()
  menuToggleEnabled = false;

  @Input()
  title: string;

  userMenuItems = [{
    text: 'Perfil',
    icon: 'fad fa-id-card fa-xs',
    onClick: () => {
      this.gotoProfile();
    },
  },
  {
    text: 'Usuarios de sistema',
    icon: 'fad fa-users fa-xs',
    onClick: () => {
      this.gotoAdminUsers();
    }
  },
  {
    text: 'Logout',
    icon: 'fad fa-sign-out-alt fa-xs',
    onClick: () => {
      this.authService.logOut();
    }
  },
  ];

  constructor(private authService: AuthService, private router: Router) { }

  toggleMenu = () => {
    this.menuToggle.emit();
  }

  gotoProfile() {
    this.router.navigate(['/dash/profile']);
  }
  gotoAdminUsers() {
    this.router.navigate(['/dash/admin-users'])
  }
}

@NgModule({
  imports: [
    CommonModule,
    DxButtonModule,
    UserPanelModule,
    DxToolbarModule
  ],
  declarations: [HeaderComponent],
  exports: [HeaderComponent]
})
export class HeaderModule { }
